<template>
  <div class="rglCodeModalBox" class-name="vertical-center-modal">
    <!-- <div class="header">监管证件代码/检验检疫代码</div> -->
    <div class="wrap-body">
      
    
            <div v-for="(item, index) in newTable" :key="index" style="margin-top:10px;display:inline-block;">
              <span>{{ item.key }}</span>
              <span>【{{ item.name }}】</span>
              <span v-if="index!=newTable.length-1">，</span>
            </div>
       
     
      
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    types: {
      type: String,
      default: ""
    },
    codes: {
      type: String,
      default: ""
    }
  },
  watch: {
    codes(newVal) {
      this.resetTable();
    },
    types(newVal) {
      this.resetTable();
    }
  },
  data() {
    return {
      newTable: [],
      tradetable: [
        {
          key: "1",
          name: "进口许可证",
          elename: "商务部配额许可证事务局或其授权机关"
        },
        { key: "2", name: "两用物项和技术进口许可证", elename: "商务部" },
        { key: "3", name: "两用物项和技术出口许可证", elename: "商务部" },
        {
          key: "4",
          name: "出口许可证",
          elename: "商务部配额许可证事务局或其授权机关"
        },
        { key: "5", name: "纺织品临时出口许可证", elename: "商务部" },
        {
          key: "6",
          name: "旧机电产品禁止进口",
          elename: "商品编码后有此代码的，其旧产品禁止进口"
        },
        { key: "7", name: "自动进口许可证", elename: "商务部" },
        {
          key: "8",
          name: "禁止出口商品",
          elename: "商品编码后有此代码的，禁止出口"
        },
        {
          key: "9",
          name: "禁止进口商品",
          elename: "商品编码后有此代码的，禁止进口"
        },

        { key: "A", name: "检验检疫", elename: "海关总署" },
        { key: "B", name: "电子底账", elename: "海关总署" },
        {
          key: "D",
          name: "出/入境货物通关单（毛坯钻石用）",
          elename: "国家质量监督检验检疫机构"
        },
        {
          key: "E",
          name: "濒危物种出口允许证",
          elename: "国家濒危物种进出口管理办公室或其他办事机构"
        },
        {
          key: "F",
          name: "濒危物种允许进口证明书",
          elename: "国家濒危物种进出口管理办公室或其他办事机构"
        },
        { key: "G", name: "两用物项和技术出口许可证(定向)", elename: "商务部" },
        {
          key: "I",
          name: "麻醉药品精神药物进出口准许证",
          elename: "国家食品药品监督管理局"
        },
        {
          key: "J",
          name: "黄金及黄金制品进出口准许证",
          elename: "中国人民银行"
        },
        {
          key: "L",
          name: "药品进出口准许证",
          elename: "国家食品药品监督管理局"
        },
        {
          key: "M",
          name: "密码产品和设备进口许可证",
          elename: "国家密码管理局"
        },
        {
          key: "O",
          name: "自动进口许可证(新旧机电产品)",
          elename: "商务部或地方商务主管机构、部门机电办"
        },
        { key: "P", name: "固体废物进口许可证", elename: "国家环保总局" },
        {
          key: "Q",
          name: "进口药品通关单",
          elename: "国家食品药品监督管理局及其授权机构"
        },
        {
          key: "R",
          name: "进口兽药通关单",
          elename: "农业部或省级人民政府兽医行政管部门"
        },
        {
          key: "S",
          name: "进出口农药登记证明",
          elename: "农业部"
        },

        { key: "U", name: "合法捕捞产品通关证明", elename: "农业部" },
        { key: "V", name: "人类遗传资源材料出口、出境证明", elename: "科技部" },
        {
          key: "X",
          name: "有毒化学品环境管理放行通知单",
          elename: "国家环保总局"
        },

        {
          key: "Z",
          name: "赴境外加工光盘进口备案证明",
          elename: "新闻出版总署"
        },

        {
          key: "b",
          name: "进口广播电影电视节目带(片)提取单",
          elename: "新闻出版总署"
        },

        { key: "d", name: "援外项目任务通知函", elename: "商务部" },

        {
          key: "f",
          name: "音像制品（成品）进口批准单",
          elename: "新闻出版总署"
        },
        { key: "g", name: "技术出口合同登记证", elename: "商务部" },
        { key: "i", name: "技术出口许可证", elename: "商务部" },
        {
          key: "k",
          name: "民用爆炸物品进出口审批单",
          elename: "工业和信息化部"
        },
        {
          key: "m",
          name: "银行调运人民币现钞进出境证明",
          elename: "中国人民银行"
        },
        {
          key: "n",
          name: "音像制品（版权引进）批准单",
          elename: "新闻出版总署"
        },
        { key: "u", name: "钟乳石出口批件", elename: "国土资源部" },
        { key: "z", name: "古生物化石出境批件", elename: "国土资源部" }
      ],
      categorytable: [
        {
          key: "L",
          name: "民用商品入境验证"
        },
        {
          key: "M",
          name: "进口商品检验"
        },
        {
          key: "N",
          name: "出口商品检验"
        },
        {
          key: "P",
          name: "进境动植物、动植物产品检验"
        },
        {
          key: "Q",
          name: "出境动植物、动植物产品检验"
        },
        {
          key: "R",
          name: "进口食品卫生监督检疫"
        },
        {
          key: "S",
          name: "出口食品卫生监督检疫"
        },
        {
          key: "V",
          name: "进境卫生检疫"
        },
        {
          key: "W",
          name: "出境卫生检疫"
        }
      ]
    };
  },
  methods: {
    resetTable() {
      let arr = [];
      if (this.types === "regulatorCode") {
        arr = this.tradetable;
      } else {
        arr = this.categorytable;
      }
      let newarr = arr.filter(item => this.codes.indexOf(item.key) >= 0);

      this.newTable = newarr;
    }
  }
};
</script>
<style scoped>
.rglCodeModalBox .vertical-center-modal,
.rglCodeModalBox .ivu-modal {
  width: 640px !important;

  margin: 0 auto;
}
.rglCodeModalBox .header {
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  margin-bottom: 20px;
}
.rglCodeModalBox .jgzj {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  border: 1px solid grey;
  border-bottom: none;
}
.wrap-body {
  /* max-height: 400px;
  overflow: hidden; */
}
.rglCodeModalBox-table {
  width: 100%;
  border: 1px solid grey;
  border-collapse: collapse;
}
.rglCodeModalBox-table thead th {
  text-align: center;
  height: 40px;
  font-size: 14px;
  font-weight: normal;
}
.rglCodeModalBox-table tbody td {
  text-align: center;
  font-size: 14px;
  height: 20px;
}
.floor2 {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/query/common/regulator2.vue